import ApiService from './_api.service'


const API_RESTOCKING_URL = '/v1/restocking/'
const API_SOLICITATIONS_URL = '/v1/solicitations/'

const AssortmentParameterService = {
    readAssortmentParameter: async function (branch) {
        let url = API_RESTOCKING_URL + 'assortment-param-agg/' + branch

        return (await ApiService.get(url)).data
    },

    createSolicitation: function (entity) {
        let data = {}

        if (entity['request_body'].length > 0) {
            let items = []
            entity['request_body'].forEach(element => {
                let item = {}
                item['solicitation_type'] = 2
                item['request_body'] = {
                    branchparameter: element.id,
                    coverage: element.coverage,
                    stock_max: element.stock_max,
                    stack_items: element.stack_items,
                    showcase_items: element.showcase_items
                }
                items.push(item)
            })
            data['items'] = items
        }

        data['request_user'] = entity['user']
        data['branch'] = entity['branch']
        data['source'] = 'A'

        return ApiService.post(API_SOLICITATIONS_URL, data)
    }
}

export default AssortmentParameterService
export { AssortmentParameterService }
